import { render, staticRenderFns } from "./YourDigitalCoinIlustra.vue?vue&type=template&id=810cb3c6&scoped=true&"
import script from "./YourDigitalCoinIlustra.vue?vue&type=script&lang=ts&"
export * from "./YourDigitalCoinIlustra.vue?vue&type=script&lang=ts&"
import style0 from "./YourDigitalCoinIlustra.vue?vue&type=style&index=0&id=810cb3c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810cb3c6",
  null
  
)

export default component.exports